/**
 * Filter the machine with given parameters
 *
 * @param {object} userInputs The user answers from the survey
 * @param {array} machineList The list of all machines
 * @return {array}
 */
export function filterMachines(userInputs, machineList) {
  let machines = []
  machineList.filter(machine => {
    const filters = Object.keys(userInputs).map(userInput => {
      const userInputUncertain =
        userInputs[userInput].includes('Sonstiges') ||
        userInputs[userInput].includes('Noch nicht sicher') ||
        userInputs[userInput].length === 0
      const fieldAvailable =
        typeof machine.filterValues[userInput] !== 'undefined'
      if (fieldAvailable === false || userInputUncertain === true) {
        return true
      }
      if (Array.isArray(userInputs[userInput]) === true) {
        return userInputs[userInput].every(element =>
          machine.filterValues[userInput].includes(element)
        )
      } else {
        return machine.filterValues[userInput].some(element =>
          userInputs[userInput].includes(element)
        )
      }
    })
    if (filters.every(x => x === true)) {
      machines.push(machine)
    }
  })
  return machines
}
